import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavService } from '../../_services/sidenav.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @Input() diviceXs: boolean;
  @Input() diviceSm: boolean;
  @Input() menuMobile: boolean

  listMenu = [];
  listBienes = [];

  constructor(private sidenav: SidenavService, private router: Router) {

    this.listBienes = [
      {
        itemName: 'Apartamentos',
        url: 'Apartamentos'
      },
      {
        itemName: 'Apartaestudio',
        url: 'Apartaestudio'
      },
      {
        itemName: 'Casas',
        url: 'Casas'
      },
      {
        itemName: 'Fincas',
        url: 'Fincas'
      },
      {
        itemName: 'Lotes',
        url: 'Lotes'
      },
      {
        itemName: 'Casas campestres',
        url: 'Casas campestres'
      },
      {
        itemName: 'Locales',
        url: 'Locales'
      },
      {
        itemName: 'Oficinas',
        url: ''
      },
      {
        itemName: 'Bodegas',
        url: 'Bodegas'
      }
    ];

    this.listMenu = [
      // {
      //   itemFather: "Celulares",
      //   // itemsChildren: [
      //   //   {
      //   //     title: "Celulares y Teléfonos",
      //   //     itemInChildren: [
      //   //       {
      //   //         itemName: "Celulares y Smartphones",
      //   //         url: "celulares"
      //   //       },
      //   //       {
      //   //         itemName: "iPhone",
      //   //         url: "iPhone"
      //   //       },
      //   //       {
      //   //         itemName: "Celulares Samsung",
      //   //         url: "samsung"
      //   //       },
      //   //       {
      //   //         itemName: "Celulares Huawei",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Celulares Motorola",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Celulares Honor",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Celulares Asus",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Celulares Xiaomi",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Celulares Neffos",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Teléfonos fijos",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Ver todo",
      //   //         url: ""
      //   //       }
      //   //     ]
      //   //   },
      //   //   {
      //   //     title: "Accesorios Celulares",
      //   //     itemInChildren: [
      //   //       {
      //   //         itemName: "Forros para celulares",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Audífonos",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Baterías externas",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Tarjetas Micro SD",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Protectores de pantalla",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Cargadores y cables",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Soporte para celulares",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Otros Accesorios",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Ver todo",
      //   //         url: ""
      //   //       }
      //   //     ]
      //   //   }
      //   // ]
      // },
      // {
      //   itemFather: "Tecnología",
      //   // itemsChildren: [
      //   //   {
      //   //     title: "TV",
      //   //     itemInChildren: [
      //   //       {
      //   //         itemName: "Televisoress",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Streaming",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Proyectores y Video Beams",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Soportes",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Accesorios TV",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Barras de Sonido",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Teatros en casa",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Ver todo",
      //   //         url: ""
      //   //       }
      //   //     ]
      //   //   },
      //   //   {
      //   //     title: "Audífonos",
      //   //     itemInChildren: [
      //   //       {
      //   //         itemName: "Audífonos Bluetooth",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Audífonos con cable",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Audífonos deportivos",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Audífonos gaming",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Ver todo",
      //   //         url: ""
      //   //       }
      //   //     ]
      //   //   },
      //   //   {
      //   //     title: "Computadores",
      //   //     itemInChildren: [
      //   //       {
      //   //         itemName: "Computadores Portátiles",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Computadores 2 en 1",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Computadores de Mesa",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Computadores Gaming",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Tablets",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Impresoras y multifuncionales",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Monitores",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Routers y Conectividad",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Accesorios Computación",
      //   //         url: ""
      //   //       },
      //   //       {
      //   //         itemName: "Ver todo",
      //   //         url: ""
      //   //       }
      //   //     ]
      //   //   }
      //   // ]
      // },
      {
        itemFather: 'Hogar',
        itemsChildren: [
          {
            title: 'Aseo',
            itemInChildren: [
              {
                itemName: 'Jabones',
                url: 'Jabones'
              },
              {
                itemName: 'Alcohol',
                url: 'Alcohol'
              },
              {
                itemName: 'Antibacterial',
                url: 'Antibacterial'
              },
              {
                itemName: 'Germisan',
                url: 'Germisan'
              },
              {
                itemName: 'Ver todo',
                url: 'Aseo'
              }
            ]
          }
        ],
      },
      // {
      //   itemFather: "Mercado",
      //   itemsChildren: null,
      // },
      {
        itemFather: 'Industrial',
        itemsChildren: [
          {
            title: 'Implementos bioseguridad',
            itemInChildren: [
              {
                itemName: 'Trajes antifluido',
                url: 'trajes-antifluido'
              },
              {
                itemName: 'Desinfectantes',
                url: 'Desinfectantes'
              },
              {
                itemName: 'Ver todo',
                url: 'Implementos bioseguridad'
              }
            ]
          },
          {
            title: 'Herramientas industriales',
            itemInChildren: [
              {
                itemName: 'Cortadoras laser',
                url: 'cortadoras-laser'
              },
              {
                itemName: "Ver todo",
                url: ""
              }
            ]
          }
        ],
      },
      // {
      //   itemFather: "Joyeria",
      //   itemsChildren: null,
      // },
      // {
      //   itemFather: "Instrumentos Musicales",
      //   itemsChildren: null,
      // }
    ];

  }

  ngOnInit(): void {
  }

  toggleRightSidenav(): void{
    this.sidenav.toggle();
  }

  closeSlidenNav(){
    this.sidenav.close();
  }
}
